import * as React from "react";
export default class ProductDetails extends React.Component {
    constructor(props) {
        super(props);
        this.productSweetness = (level) => {
            let sweet = parseFloat(level);
            switch (true) {
                case sweet < 1:
                    return "Very Dry";
                case sweet <= 2:
                    return "Off Dry";
                case sweet <= 4:
                    return "Medium";
                case sweet <= 6:
                    return "Sweet";
                case sweet <= 10:
                    return "Very Sweet";
                default:
                    return "Very Dry";
            }
        };
    }
    render() {
        let product = this.props.product;
        let sizeNumber = parseFloat(product.Size);
        let sizeText = !isNaN(sizeNumber) ? `${sizeNumber}ml` : '';
        if (!isNaN(sizeNumber) && product.SinglesPerUnit < 2 && sizeNumber >= 1000) {
            sizeText = `${sizeNumber / 1000}L`;
        }
        else if (!isNaN(sizeNumber) && sizeNumber > 0 && product.SinglesPerUnit > 1) {
            let sizePerUnit = sizeNumber / product.SinglesPerUnit;
            sizeText = `${sizePerUnit}ml x ${product.SinglesPerUnit}`;
        }
        let productColour = product.ColourNumber && React.createElement("p", null,
            React.createElement("span", null, "Colour:"),
            " ",
            product.Colour);
        if (product.Colour && product.ConsumerCategory == 'beer') {
            productColour = React.createElement("p", { className: "beer-colour-container" },
                React.createElement("span", null, "Colour:"),
                React.createElement("span", null,
                    React.createElement("span", { className: `beer-colour beer-colour-${product.ColourNumber}` }, product.Colour),
                    React.createElement("span", null,
                        React.createElement("input", { type: "range", min: "1", max: "40", className: "beer-colour-range small-range", value: product.ColourNumber, disabled: true }))));
        }
        var formatter = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
        });
        return (React.createElement("div", { className: "product-details" },
            React.createElement("h6", { className: "detail-header" }, "Details"),
            React.createElement("div", null,
                product.Country &&
                    React.createElement("p", null,
                        React.createElement("span", null, "Country:"),
                        " ",
                        product.Country),
                product.Region &&
                    React.createElement("p", null,
                        React.createElement("span", null, "Region:"),
                        " ",
                        product.Region),
                product.Supplier &&
                    React.createElement("p", null,
                        React.createElement("span", null, "Supplier: "),
                        " ",
                        product.Supplier),
                product.AgentId && product.AgentName && product.Agent &&
                    React.createElement("p", null,
                        React.createElement("span", null, "Agent:"),
                        " ",
                        React.createElement("a", { href: `/Products/Agents/${product.Agent.Number}` }, product.AgentName)),
                sizeText &&
                    React.createElement("p", null,
                        React.createElement("span", null, "Volume:"),
                        " ",
                        sizeText),
                product.PercentAlcohol &&
                    React.createElement("p", null,
                        React.createElement("span", null, "Alcohol (%):"),
                        " ",
                        product.PercentAlcohol),
                product.UnitDeposit &&
                    React.createElement("p", null,
                        React.createElement("span", null, "Deposit:"),
                        " ",
                        formatter.format(product.UnitDeposit)),
                product.ConsumerCategory == 'wine' && product.SubType &&
                    React.createElement("p", null,
                        React.createElement("span", null, "Varietal:"),
                        " ",
                        product.SubType),
                product.Container &&
                    React.createElement("p", null,
                        React.createElement("span", null, "Container:"),
                        " ",
                        product.Container),
                productColour,
                product.ConsumerCategory == 'wine' && product.Sweetness &&
                    React.createElement("p", null,
                        React.createElement("span", null, "Sweetness:"),
                        " ",
                        product.Sweetness,
                        " (",
                        this.productSweetness(product.Sweetness),
                        ")"),
                product.ConsumerCategory == 'wine' && product.Sugar &&
                    React.createElement("p", null,
                        React.createElement("span", null, "Sugar:"),
                        " ",
                        product.Sugar,
                        " grams of sugar per litre"),
                product.ConsumerCategory == 'wine' && product.Vintage &&
                    React.createElement("p", null,
                        React.createElement("span", null, "Vintage:"),
                        " ",
                        product.Vintage),
                product.IBU && product.ConsumerCategory == 'beer' ?
                    (React.createElement("p", null,
                        React.createElement("i", { className: "fa fa-question-circle", title: "International Bitterness Unit - Generally indicative of how bitter a beer will taste. Generally speaking, the more IBU's the more bitter it will taste" }),
                        " ",
                        React.createElement("span", null, "IBU:"),
                        " ",
                        product.IBU))
                    : null,
                product.ConsumerCategory == 'beer' && product.Aroma &&
                    React.createElement("p", null,
                        React.createElement("span", null, "Aroma:"),
                        " ",
                        product.Aroma))));
    }
}
;
//# sourceMappingURL=product-details.js.map